import { Wordmark } from "@/components/brand/Wordmark";

interface LogoProps {
  variant?: "icon-wordmark" | "icon" | "wordmark";
  className?: string;
  /** Set true when the logo sits on an ink/dark surface (e.g. sidebar, footer). */
  inverted?: boolean;
  /** Kept for API compatibility; the logistics lockup carries no ™ mark. */
  trademark?: boolean;
}

/**
 * The app logo. Now the Zupa for Logistics lockup (ink/paper, cargo sub-mark) — see
 * components/brand/Wordmark. `variant="icon"` renders the compact ink-square Z mark; every
 * other variant renders the full lockup. Delegating here flips every existing <Logo> call
 * site to the new identity at once.
 */
export function Logo({ className, inverted = false, variant = "icon-wordmark" }: LogoProps) {
  return (
    <Wordmark
      className={className}
      inverted={inverted}
      variant={variant === "icon" ? "mark" : "lockup"}
    />
  );
}
